import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { PostsService } from '@stop-counter/shared/services';
import { PostsStoreService } from './store.service';
import { Effects } from './effects';
import { reducer } from './reducer';

@NgModule({
  imports: [
    StoreModule.forFeature('posts', reducer),
    EffectsModule.forFeature([Effects])
  ],
  exports: [StoreModule, EffectsModule],
  providers: [PostsStoreService, PostsService]
})
export class PostsStoreModule {}
